import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  type OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { LazyStylesService } from '@cue/lazy-styles';

import { loadNavigationOpenLayersStyles } from '../../lazy-styles/navigation-lazy-styles';

@Component({
  selector: 'cue-open-layers-styles',
  imports: [],
  host: {
    '[class.kiosk]': 'kioskMode()',
  },
  templateUrl: './open-layers-styles.component.html',
  styleUrl: './open-layers-styles.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class OpenLayersStylesComponent implements OnInit {
  private readonly lazyStyles = inject(LazyStylesService);

  kioskMode = input<boolean, boolean | 'true' | 'false'>(false, {
    transform: booleanAttribute,
  });

  ngOnInit(): void {
    void loadNavigationOpenLayersStyles(this.lazyStyles);
  }
}
